import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Navigate, Routes } from 'react-router-dom';
import userContext from '../context/userContext';

import Login from '../screens/signin';
import Home from '../screens/home';


const Navigation = () => {
    const { user } = useContext(userContext);
    return (
        <Router>
            <Routes>
                <Route exact path="/login" element={!user ? <Login/> : <Navigate to="/"/>} />
                <Route exact path="/" element={user ? <Home/> : <Navigate to="/login"/>} />
                <Route path='*' element={<Login/>} />
            </Routes>
        </Router>
    )
}

export default Navigation;
